import React from 'react';
import PropTypes from 'prop-types';
import { ProgressCircles } from '../../elements-progress-indicator/progress-circles';

export const SyncFlowFooter = ({
  backAction,
  currentIndex,
  totalLength
}) => (
  <div className="container-fluid text-center">
    <div className="row">
      <div className="col-xs-12">
        <ProgressCircles
          currentIndex={currentIndex}
          totalLength={totalLength}
          backAction={backAction}
        />
      </div>
    </div>
  </div>
);

SyncFlowFooter.propTypes = {
  backAction: PropTypes.func,
  currentIndex: PropTypes.number,
  totalLength: PropTypes.number
};
